import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';

/**
 * ControllerClass must extend YamsCoreController
 * @typedef {import('../controllers/YamsCoreController.js').YamsCoreController} YamsCoreController;
 * @param controller {typeof YamsCoreController}
 * @returns {{ref: (obj) => void, api: YamsCoreController}}
 */
export var useYamsListener = function useYamsListener(controller) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    setHash = _useState2[1];

  /** Do both: subscribe and unsubscribe */
  useEffect(function () {
    return controller.subscribe(function () {
      return setHash(Math.random());
    });
  }, [controller]);
};